const LOCALE_CORRECTION_MAP = {
    'en_US': 'us_US',
    'en_AE': 'en_GULF',
    'en_CA': 'us_CA',
    'en_JP': 'us_JP'
};

class LocaleService {

    constructor(locale) {

        if (LOCALE_CORRECTION_MAP[locale] !== undefined) {
            this.locale = LOCALE_CORRECTION_MAP[locale];
        } else {
            this.locale = locale;
        }

    }

    getLanguage = function () {
        return this.locale === undefined ? null : this.locale.split('_')[0];
    };

    getLocale = function () {
        return this.locale;
    };

}

export default LocaleService;
